// extracted by mini-css-extract-plugin
module.exports = {"hoverlessContainer":"style_hoverlessContainer__aJ6c-","logo":"style_logo__1Vll7"};